<template>
  <div class="stopwatch">
    <div class="timerDisplay">{{ formattedTime }}</div>
  </div>
</template>

<script lang="ts">
import { Vue } from 'vue-class-component';

export default class RaceTimer extends Vue {
  startTime = 0;
  elapsedTime = 0;
  timerId = 0;
  isRunning = false;

  get formattedTime() {
    const totalMilliseconds = this.elapsedTime;
    const minutes = Math.floor(totalMilliseconds / 60000);
    const seconds = Math.floor((totalMilliseconds % 60000) / 1000);
    const milliseconds = Math.floor((totalMilliseconds % 1000) / 10);
    
    const m = minutes > 9 ? minutes : '0' + minutes;
    const s = seconds > 9 ? seconds : '0' + seconds;
    const ms = milliseconds.toString().padStart(2, '0');
    
    return `${m}:${s}:${ms}`;
  }

  updateElapsedTime() {
    if (this.isRunning) {
      const now = Date.now();
      this.elapsedTime = now - this.startTime;
      this.timerId = requestAnimationFrame(this.updateElapsedTime.bind(this));
    }
  }

  startTimer() {
    if (!this.isRunning) {
      this.isRunning = true;
      this.startTime = Date.now() - this.elapsedTime; // resume from last elapsed time
      this.updateElapsedTime();
    }
  }

  stopTimer() {
    this.isRunning = false;
    cancelAnimationFrame(this.timerId);
  }

  clearTimer() {
    this.isRunning = false;
    cancelAnimationFrame(this.timerId);
    this.elapsedTime = 0;
  }

  public setTimeFromString(timeString: string): void {
    const timePattern = /^\d{2}:\d{2}:\d{2}$/;
    if (!timePattern.test(timeString)) {
      throw new Error(`Invalid time format: ${timeString}. Expected format is MM:SS:MS.`);
    }
    const [minutes, seconds, milliseconds] = timeString.split(':').map(Number);
    if (seconds >= 60 || milliseconds >= 100) {
      throw new Error('Invalid time values. Seconds must be less than 60, and milliseconds must be less than 100.');
    }
    this.elapsedTime = minutes * 60000 + seconds * 1000 + milliseconds * 10;
  }

}
</script>

<style scoped>

</style>
